import classNames from "classnames";
import { CalendarMode, CalendarView, Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { Button } from "PFComponents/button";
import RightArrowIcon from "PFIcons/right_arrow.svg";
import React, { JSX } from "react";

import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import css from "../side_panel_rows.module.scss";
import { checkIsLastLevel } from "./side_panel_row.utils";

type RowExpanderProps = {
  row: Row;
  onClick: VoidFunction;
  disabled: boolean;
  expanded: boolean;
};

export const RowExpander = ({ row, onClick, disabled, expanded }: RowExpanderProps): JSX.Element => {
  const { calendarData, calendarMode } = useBookingsOverviewContext();

  const { view } = calendarData;
  const { type } = row;
  const isWorkforceMode = calendarMode === CalendarMode.Workforce;

  const isLastLevel = checkIsLastLevel(calendarMode, row);

  const isSummary =
    calendarMode === CalendarMode.Workforce && type === RowType.Profile && view !== CalendarView.BookingsOnly;
  const isWorkforceExpandableRow = isWorkforceMode && isSummary;
  const isProjectsExpandableRow = !isWorkforceMode && !isLastLevel;

  return (
    <Button kind="blank" onClick={onClick} disabled={disabled || isLastLevel}>
      {(isWorkforceExpandableRow || isProjectsExpandableRow) && (
        <RightArrowIcon
          className={classNames(css.icon, {
            [css.opened]: expanded
          })}
          height={20}
        />
      )}
    </Button>
  );
};
